import { render, staticRenderFns } from "./AppLayoutAsk.vue?vue&type=template&id=0be525d2&scoped=true&"
import script from "./AppLayoutAsk.vue?vue&type=script&lang=js&"
export * from "./AppLayoutAsk.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutAsk.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppLayoutAsk.vue?vue&type=style&index=1&id=0be525d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be525d2",
  null
  
)

export default component.exports